exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-notes[data-v-0812009a]{max-width:1200px;margin:0 auto}.user-notes h4[data-v-0812009a]{text-align:center;font-weight:500;font-size:18px;margin:10px 0}.user-notes p[data-v-0812009a]{font-size:14px;color:#333;margin-bottom:7px}.user-notes p span[data-v-0812009a]{display:block;margin:0;padding:0}.user-notes p .content[data-v-0812009a]{text-indent:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0812009a","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/insure/userNotes.vue
// module id = w6fg
// module chunks = 225